module.exports = __webpack_public_path__ + "static/media/wework_x3.7779b459.png";